import http from "../http-common";

class ProctorUnavailableService {
  createProctorUnavailable(data) {
    return http.post(`/api/proctor_unavailable`, data);
  }
  getProctorUnavailables() {
    return http.get(`/api/proctor_unavailable/getAll`);
  }
  getUnavailableExaminerByFilter(data){
    return http.get(`/api/proctor_unavailable/getUnavailableExaminerByFilter?year_term_type_id=`+data.year_term_type_id+'&&proctor_id='+data.proctor_id+'&&date='+data.date+'&&time_from='+data.time_from);
  }
  updateProctorUnavailable(id, data) {
    return http.put(`/api/proctor_unavailable/${id}`, data);
  }
}

export default new ProctorUnavailableService();